import axiosClient from './client';

export const updateTrackedAccount = (id, data) => (
  axiosClient().put(`/tracked_accounts/${id}`, { trackedAccount: data })
)
